import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { CatalogBasic } from 'src/app/models/catalogs-model/catalog.model';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { empty } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';

@Component({
  selector: 'app-catalogs-catalog-products-card',
  templateUrl: './catalogs-catalog-products-card.component.html',
  styleUrls: ['./catalogs-catalog-products-card.component.scss']
})
export class CatalogsCatalogProductsCardComponent implements OnInit, OnDestroy {

  @Input() catalog: CatalogBasic;
  products;
  selectedProducts;
  updateCatalogProductsSubscription: Subscription;
  getProductsSubscription: Subscription;

  constructor(private catalogsService: CatalogsService,
              private productsService: ProductsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.getProducts();
  }

  public duallistboxOutputEventReceiver(selectedProducts) {
    const aux = new Array();
    for (const d of selectedProducts) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedProducts = aux;
      this.updateCatalogProducts(this.getProductsInternalIds(this.selectedProducts));
    }
  }

  public getProducts() {
    this.getProductsSubscription = this.productsService.getProductsList().pipe(
      tap(o => this.products = o)
    ).subscribe();
  }

  public updateCatalogProducts(productsInternalIds) {
    this.updateCatalogProductsSubscription = this.catalogsService.updateCatalogProducts(this.catalog.InternalId, productsInternalIds).pipe(
      tap(o => this.catalogsService.refreshCatalog()),
      tap(o => this.snackbarService.open('catalogs-page.snackbar messages.update catalog success', 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private getProductsInternalIds(products) {
    if (products) {
      return products.map(p => p.InternalId);
    }
    return [];
  }
  ngOnDestroy() {
    if (this.updateCatalogProductsSubscription) { this.updateCatalogProductsSubscription.unsubscribe(); }
    if (this.getProductsSubscription) { this.getProductsSubscription.unsubscribe(); }
  }

}
